import {BACKEND} from "../config/backend";
import {axiosPrivate} from "../axios-config/axiosPrivate";
import {axiosPublic} from "../axios-config/axiosPublic";
import {standardRequestConfig} from "../axios-config/requestConfig";

export const getCountryMap = () => {
    return axiosPublic.get(`${BACKEND}/api/v1/countries`)
}

export const getStudio = () => {
    return axiosPrivate.get(`${BACKEND}/api/v1/studio`, {
        ...standardRequestConfig
    })
}

export const updateStudio = ({studio}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/studio`, studio, {
        ...standardRequestConfig
    })
}

export const getTermintypen = () => {
    return axiosPrivate.get(`${BACKEND}/api/v1/studio/termintypen`, {
        ...standardRequestConfig
    })
}
